import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import dateService from '@gem/services/date-service';
import { customScrollStyles, IconView, MenuItem } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { useAboutPopupPresenter } from './AboutPopup.presenter';
import styles from './AboutPopup.styles.m.css';

export const AboutPopup: FC<ICommonPopupsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useAboutPopupPresenter(props);
  useClosePopupOnNavigation(props.popupInstance);

  return (
    <Popup
      isOpened
      handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
      onClose={presenter.onClose}
    >
      <div className={classNames(styles.container, customScrollStyles.container)}>
        <div className={styles.info}>
          <img
            src={getMascotImageSrc('logo.svg')}
            className={styles.logo}
            alt={PROJECT_CONFIG.projectName}
          />
          <h1 className={styles.title}>{t('about_gem4me_title')}</h1>
          <span
            className={styles.version}
            onClick={presenter.onVersionClick}
          >
            {t('about_version', { 0: presenter.version })}
          </span>
        </div>

        {presenter.menuItems.map((menuItem) => (
          <MenuItem
            key={menuItem.key}
            className={styles.listItem}
            title={menuItem.title}
            icon={
              <IconView
                Icon={menuItem.Icon}
                className={styles.listIcon}
              />
            }
            onClick={menuItem.onClick}
          />
        ))}

        <p className={styles.copyright}>
          {t('about_copyright', { 0: dateService.now().getFullYear().toString() })}
        </p>
      </div>
    </Popup>
  );
});
